export default __webpack_public_path__ + "static/media/Twitter.cfbe6fc4.svg";